module.exports = __webpack_public_path__ + "assets/e96e94cb80855f73984f6d55313e431f.svg";